export default __webpack_public_path__ + "static/media/330_store03-fr-mobile.19e7be05.png";